<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-30 17:29:20
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:03:50
 * @name: 添加或编辑人员
 * @Description: 添加或编辑人员(按是否传id区分)
 * @FilePath: \preSaleNafterSaleBackstage\src\components\role\person-edit-add.vue
 * @Author: desktop
-->
<template>
  <el-dialog :title="title" :visible.sync="show" @close="close">
    <div class="form">
      <div class="name">
        <span class="label">用户名</span>
        <el-input
          class="input"
          v-model="form.name"
          placeholder="请输入用户名..."
          clearable
        ></el-input>
      </div>
      <div class="role_ids">
        <span class="label">角色</span>
        <el-select
          class="input"
          v-model="form.role_ids"
          placeholder="请选择角色..."
          multiple
        >
          <el-option
            :label="item.role_name"
            :value="item.id"
            v-for="item of role_list"
            :key="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="password">
        <span class="label">密码</span>
        <el-input
          class="input"
          type="password"
          v-model="form.password"
          placeholder="请输入密码..."
          clearable
        ></el-input>
      </div>
      <div class="btn-group">
        <el-button size="small" plain @click="show = false">取消</el-button>
        <el-button size="small" type="primary" @click="save">保存</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { adminRoleGetAllList } from "@/api/admin_role/admin_role.api";
import { adminAdd, adminDetail, adminEdit } from "@/api/admin/admin.api";
import { debounceation } from "@/utils/decorator";
export default {
  data() {
    return {
      show: false,
      id: "",
      title: "",
      form: {
        name: "",
        password: "",
        role_ids: [],
      },
      role_list: [],
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {String} id 人员id
     */
    open(id) {
      this.title = id ? "编辑人员" : "添加人员";
      this.id = id;
      adminRoleGetAllList().then((res) => {
        this.role_list = res.data;
      });
      adminDetail({ id }).then((res) => {
        this.form.name = res.data?.username ?? "";
        this.form.role_ids = (res.data?.role_ids.value ?? []).map((x) =>
          Number(x)
        );
        this.show = true;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.form.name = "";
      this.form.role_ids = [];
      this.form.password = "";
      this.role_list = [];
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击保存
     */
    @debounceation(300)
    save() {
      if (this.id) {
        adminEdit({ id: this.id, ...this.form }).then((res) => {
          this.$message.success("保存成功");
          this.$emit("saveSuccess");
          this.show = false;
        });
      } else {
        adminAdd({ ...this.form }).then((res) => {
          this.$message.success("保存成功");
          this.$emit("saveSuccess");
          this.show = false;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  width: 100%;
  @extend .extend-flex-column-center;
  .name,
  .password {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    @extend .extend-flex-start;
    .label {
      font-size: $Vars-font-miniTitle-size;
      flex-shrink: 0;
      width: calc(#{$Vars-font-miniTitle-size} * 3);
      margin-right: 20px;
    }
    .input {
      flex: 1;
    }
  }
  .password {
    margin-top: 30px;
  }
  .role_ids {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    margin-top: 30px;
    @extend .extend-flex-start;
    .label {
      font-size: $Vars-font-miniTitle-size;
      flex-shrink: 0;
      width: calc(#{$Vars-font-miniTitle-size} * 3);
      margin-right: 20px;
    }
    .input {
      flex: 1;
    }
  }
  .btn-group {
    margin-top: 20px;
  }
}
</style>